import { Markdown, Title } from '../components/common'

import Layout from '../components/layout'
import { OutboundLink } from 'gatsby-plugin-google-analytics'
import React from 'react'
import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import { useStaticQuery, graphql } from 'gatsby'

const Privacy = () => {
  const privacypage = useStaticQuery(graphql`
    query allprivacys {
      allMarkdownRemark {
        nodes {
          frontmatter {
            description
            heading
            templateKey
            title
          }
        }
      }
    }
  `)

  const {
    allMarkdownRemark: { nodes },
  } = privacypage
  const privacyData = nodes.filter(
    data => data.frontmatter.templateKey === 'privacy-page'
  )?.[0]

  // console.log(privacyData)

  return (
    <Layout>
      <Markdown>
        <Title id="-privacy-policy-">
          <strong>{privacyData.frontmatter.heading}</strong>
        </Title>
        <Wrapper className="text-white">
          <ReactMarkdown>{privacyData.frontmatter.description}</ReactMarkdown>
        </Wrapper>
      </Markdown>
    </Layout>
  )
}

const Wrapper = styled.div`
  color: white;
  text-align: justify;
`

export default Privacy
